export const AccountStatus = {
  ACTIVE: "Active",
  BLOCKED: "Blocked",
  INACTIVE: "Inactive",
  DELETED: "Deleted"
};
